<script setup>
import {computed} from 'vue'
import api from '@/services/api'

const props = defineProps({
    item: Object,
    value: Number
})

const typeId = computed(() => (props.item && props.item.typeId) || 0)

const formattedValue = computed(() =>
    new Intl.NumberFormat().format(props.value || 0)
)

const goToVariations = async () => {
    try {
        const {data} = await api.get('api/Products/getTypesTableNames')
        window.location = `/#/${data[typeId.value]}?productId=${props.item.id}`
    } catch (error) {
        console.error('Failed to resolve variations route:', error)
    }
}
</script>

<template>
    <div v-if="typeId > 0">
        <button class="btn btn-light btn-sm" type="button" @click="goToVariations">
            {{ formattedValue }}
        </button>
    </div>
</template>